import React, { useState } from "react";

import Button from "components/atoms/button/Button";
import RadioButton from "components/atoms/form/RadioButton";
import Text from "components/atoms/text/Text";

import {
    InitialFieldBody,
    InitialFieldCard,
    InitialFieldChevron,
    InitialFieldHeader,
    InitialFieldPrompt,
    InitialFieldSummary,
    InlineInput,
    InlineInputRow,
    InputWrap,
    IntroDescription,
    OptionDescription,
    OptionTextWrap,
    PanelCard,
    QueryInput,
    QuestionOptionRow,
} from "components/page/searchAgent/styled";

export default function RequestStepSection({
    ready,
    queryInput,
    onQueryInputChange,
    initialFields,
    initialSelections,
    initialCustomInputs,
    onSelectInitialOption,
    onChangeInitialCustomInput,
    onSubmitRequest,
    canSubmitRequest,
}) {
    const [expandedCategory, setExpandedCategory] = useState("");

    const toggleCategory = (category) => {
        setExpandedCategory((prev) => (prev === category ? "" : category));
    };

    return (
        <PanelCard>
            <Text variant={"styled-md"}>기본 조건</Text>
            {initialFields.map((field) => {
                const selectedOptionId = initialSelections[field.category];
                const selectedOption =
                    field.options.find((option) => option.id === selectedOptionId) || field.options[0];
                const selectedSummaryDescription =
                    selectedOption?.id === "other"
                        ? (initialCustomInputs[field.category] || "").trim() || selectedOption?.description
                        : selectedOption?.description;
                const isExpanded = expandedCategory === field.category;
                return (
                    <InitialFieldCard key={field.category} collapsible expanded={isExpanded}>
                        <InitialFieldHeader
                            type="button"
                            onClick={() => toggleCategory(field.category)}
                            aria-expanded={isExpanded}
                            aria-controls={`initial-field-body-${field.category}`}
                        >
                            <div>
                                <InitialFieldPrompt>{field.prompt}</InitialFieldPrompt>
                                <InitialFieldSummary>
                                    {selectedOption?.label}
                                    {selectedSummaryDescription ? ` - ${selectedSummaryDescription}` : ""}
                                </InitialFieldSummary>
                            </div>
                            <InitialFieldChevron expanded={isExpanded}>⌄</InitialFieldChevron>
                        </InitialFieldHeader>

                        {isExpanded && (
                            <InitialFieldBody id={`initial-field-body-${field.category}`}>
                                <div>
                                    {field.options.map((option) => (
                                        <QuestionOptionRow key={`${field.category}-${option.id}`}>
                                            <RadioButton
                                                type="radio"
                                                name={`initial-${field.category}`}
                                                label={option.label}
                                                checked={selectedOptionId === option.id}
                                                onChange={() => {
                                                    onSelectInitialOption(field.category, option.id);
                                                    if (option.id !== "other") {
                                                        setExpandedCategory("");
                                                    }
                                                }}
                                                disabled={!ready}
                                            />
                                            <OptionTextWrap>
                                                <OptionDescription>{option.description}</OptionDescription>
                                            </OptionTextWrap>
                                        </QuestionOptionRow>
                                    ))}
                                </div>
                                {selectedOptionId === "other" && (
                                    <InlineInputRow>
                                        <InlineInput
                                            value={initialCustomInputs[field.category] || ""}
                                            onChange={(e) => onChangeInitialCustomInput(field.category, e.target.value)}
                                            placeholder={field.customPlaceholder}
                                            disabled={!ready}
                                        />
                                    </InlineInputRow>
                                )}
                            </InitialFieldBody>
                        )}
                    </InitialFieldCard>
                );
            })}

            <Text variant={"styled-md"} margin={"40px 0px 0px 0px"}>
                연구 주제
            </Text>
            <IntroDescription>기본 조건과 연구 주제를 입력하면 계획 단계를 시작합니다.</IntroDescription>

            <InputWrap>
                <QueryInput
                    value={queryInput}
                    onChange={(e) => onQueryInputChange(e.target.value)}
                    placeholder="에이전트가 검색할 연구 주제를 입력하세요."
                    disabled={!ready}
                />
                <Button
                    onlyText
                    width={"140px"}
                    height={"44px"}
                    size={"small"}
                    bgColor={"var(--color-Button1)"}
                    hoverBgColor={"var(--color-ButtonHover1)"}
                    fontColor={"var(--color-White)"}
                    buttonText={"계획 시작"}
                    onClick={onSubmitRequest}
                    disabled={!canSubmitRequest}
                />
            </InputWrap>
        </PanelCard>
    );
}
